module.exports = __webpack_public_path__ + "media/images/icons/twotone/red-envelope-4403b25549edd2216664a9dd9dd60b7a.svg";